function b64EncodeUnicode(str) {
  // first we use encodeURIComponent to get percent-encoded UTF-8,
  // then we convert the percent encodings into raw bytes which
  // can be fed into btoa.
  return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g,
    function toSolidBytes(match, p1) {
      return String.fromCharCode('0x' + p1);
    }));
}

const creatorUrl = 'https://www.quickchords.org'

function makeCreatorLink({flavor, artist, title, collection = '0', embed, source}) {
  const xcollection = encodeURIComponent(fixup(collection))
  const xartist = encodeURIComponent(fixup(artist))
  const xtitle = encodeURIComponent(fixup(title))

  let ret;
  ret = `${creatorUrl}/${flavor}/${xcollection}/${xartist}/${xtitle}`;
  ret += '?view=Left'
  if (source) {
    const xsource = encodeURIComponent(source)
    ret += `&source=${xsource}`
  }
  if (embed) {
    const xchart = encodeURIComponent(b64EncodeUnicode(embed))
    ret += `&chart=${xchart}`
  }
  return ret
}

function fixup(s) {
  if (!s) {
    return s
  }
  return s.toLowerCase().replace(/[^a-zA-Z0-9_ ]/g, '').replace(/ /g, '_')
}

export default {
  fixup,
  makeCreatorLink
}